// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 378 ? "user" : chunkId) + "." + {"68":"64f72bcc","378":"1b786142","529":"cebd61f0"}[chunkId] + ".chunk.js";
};